// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1p6AS","signatureBlock":"Footer_signatureBlock__1qlje","signature":"Footer_signature__DA5E-"};